import React, { Component } from 'react'
// import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
// import * as actionCreators from '../../actions';
import { renderSelectField } from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
// import Popover from 'material-ui/Popover';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';

// import * as actionCreator from '../../actions'

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  thin: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  halfthin: {
    paddingBottom: 0,
    marginBottom: 0,
    background: '#E1F5FE',
  },
  tobottom: {
    bottom: 0,
    top: "auto"
  }
};

class TbstatisticsFilter extends Component {

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  renderAutomated() {
    if(typeof this.props.affairautomated !== 'undefined') {
      return <Field
          component={renderSelectField}
          floatingLabelText="automata"
          name="automated"
          defaultValue="all"
          menuStyle={{top: 'auto', bottom: 0}}
        >
          {
            this.props.affairautomated.map((option, index) => {
              switch (option.value) {
                case 'all': 
                  return <MenuItem key={index} value={option.value} primaryText="összes" />
                case 'true': 
                  return <MenuItem key={index} value={option.value} primaryText="automata ügyek" />
                case 'false': 
                  return <MenuItem key={index} value={option.value} primaryText="kézi ügyek" />
                default: 
                  return <MenuItem key={index} value={option.value} primaryText={option.value} />
              }
            })
          }
        </Field>
    }
  }

  render() {
    // console.log(this)
    const {handleSubmit} = this.props
    return (
      <div>
        {this.renderAlert()}
        <Paper zDepth={1} style={{/*position: "fixed", bottom:"0",*/ width:"100%", background: "#E1F5FE", zIndex: "10"}}>
            <form onSubmit={handleSubmit} className='flexContainer'>
              <Paper zDepth={0} style={styles.thin}>
                <Field
                  component={renderSelectField}
                  floatingLabelText="kategória"
                  name="category"
                  defaultValue="all"
                  menuStyle={{top: 'auto', bottom: 0}}
                >
                  <MenuItem key={101} value='all' primaryText='Összes' />
                  {
                    typeof this.props.affaircategories !== 'undefined' ? this.props.affaircategories.map((option, index) => {
                      return <MenuItem key={index} value={option} primaryText={option} />
                    }) : void(0)
                  }
                </Field>
              </Paper>
              <Paper zDepth={0} style={styles.thin}>
                {this.renderAutomated()}
              </Paper>
              { /*
                <Paper zDepth={0} style={styles.halfthin}>
                  <Field
                    component={renderCheckbox}
                    label="Automatikus ügy"
                    name="automated"
                    style={styles.checkbox}
                  />
                </Paper>
                */
              }
              <Paper zDepth={0} style={styles.halfthin}>
                <RaisedButton type="submit" label="szűrés" primary={true} labelColor={'#FFFFFF'}/>
              </Paper>
            </form>
        </Paper>
      </div>
    )
  }

}

// PersonListFilter = reduxForm({
//   form: 'personListFilter'
// })(PersonListFilter)

// You have to connect() to any reducers that you wish to connect to yourself
//PersonListFilter = connect(
  //state => ({
  //  initialValues: state.person.thisperson // pull initial values from reducer
  //})//,
  //{ load: loadAccount }               // bind account loading action creator
//)(PersonListFilter)

export default reduxForm({
  form: 'tbstatisticsFilter',
  initialValues: {category: 'all', automated: 'all'}
})(TbstatisticsFilter)


// WEBPACK FOOTER //
// ./src/components/tbstatistics/tbstatisticsFilter.js